import Cookies from "js-cookie";
import {
  ADD_NEW_PATIENT_FAIL,
  ADD_NEW_PATIENT_REQUEST,
  ADD_NEW_PATIENT_SUCCESS,
  ADD_PATIENT_DETAILS_FAIL,
  ADD_PATIENT_DETAILS_REQUEST,
  ADD_PATIENT_DETAILS_SUCCESS,
  ADD_PATIENT_PASSWORD_FAIL,
  ADD_PATIENT_PASSWORD_REQUEST,
  ADD_PATIENT_PASSWORD_SUCCESS,
  ADD_RECORD_CONSENT_FAIL,
  ADD_RECORD_CONSENT_REQUEST,
  ADD_RECORD_CONSENT_SUCCESS,
  CREATE_ENROLMENT_FAIL,
  CREATE_ENROLMENT_REQUEST,
  CREATE_ENROLMENT_SUCCESS,
  DELETE_PATIENT_FAIL,
  DELETE_PATIENT_NOTE_FAIL,
  DELETE_PATIENT_NOTE_REQUEST,
  DELETE_PATIENT_NOTE_SUCCESS,
  DELETE_PATIENT_REQUEST,
  DELETE_PATIENT_SUCCESS,
  EDUCATION_SETUP_FAIL,
  EDUCATION_SETUP_REQUEST,
  EDUCATION_SETUP_SUCCESS,
  EQUIP_SETUP_FAIL,
  EQUIP_SETUP_REQUEST,
  EQUIP_SETUP_SUCCESS,
  GENERATE_EVIDENCE_FAIL,
  GENERATE_EVIDENCE_REQUEST,
  GENERATE_EVIDENCE_SUCCESS,
  GET_AGENCY_PATIENTS_FAIL,
  GET_AGENCY_PATIENTS_REQUEST,
  GET_AGENCY_PATIENTS_SUCCESS,
  GET_ALL_PATIENTS_FAIL,
  GET_ALL_PATIENTS_REQUEST,
  GET_ALL_PATIENTS_SUCCESS,
  GET_A_PATIENT_BY_PID_FAIL,
  GET_A_PATIENT_BY_PID_REQUEST,
  GET_A_PATIENT_BY_PID_SUCCESS,
  GET_CHART_PAINLOGS_FAIL,
  GET_CHART_PAINLOGS_REQUEST,
  GET_CHART_PAINLOGS_SUCCESS,
  GET_CLIENT_PAINLOGS_FAIL,
  GET_CLIENT_PAINLOGS_REQUEST,
  GET_CLIENT_PAINLOGS_SUCCESS,
  GET_DASHBOARD_ALERTS_FAIL,
  GET_DASHBOARD_ALERTS_REQUEST,
  GET_DASHBOARD_ALERTS_SUCCESS,
  GET_DASHBOARD_ANALYTICS_FAIL,
  GET_DASHBOARD_ANALYTICS_REQUEST,
  GET_DASHBOARD_ANALYTICS_SUCCESS,
  GET_ENROLMENTS_LIST_FAIL,
  GET_ENROLMENTS_LIST_REQUEST,
  GET_ENROLMENTS_LIST_SUCCESS,
  GET_ENROLMENT_TIMELINE_FAIL,
  GET_ENROLMENT_TIMELINE_REQUEST,
  GET_ENROLMENT_TIMELINE_SUCCESS,
  GET_LAST_LAB_DATE_FAIL,
  GET_LAST_LAB_DATE_REQUEST,
  GET_LAST_LAB_DATE_SUCCESS,
  GET_BMI_RESPONSES_FAIL,
  GET_BMI_RESPONSES_REQUEST,
  GET_BMI_RESPONSES_SUCCESS,
  GET_MEDICINE_DATA_FAIL,
  GET_MEDICINE_DATA_REQUEST,
  GET_MEDICINE_DATA_SUCCESS,
  GET_PHQ_RESPONSES_FAIL,
  GET_PHQ_RESPONSES_REQUEST,
  GET_PHQ_RESPONSES_SUCCESS,
  GET_QOL_ANSWERS_FAIL,
  GET_QOL_ANSWERS_REQUEST,
  GET_QOL_ANSWERS_SUCCESS,
  GET_MINIMISED_NOTE_FAIL,
  GET_MINIMISED_NOTE_REQUEST,
  GET_MINIMISED_NOTE_SUCCESS,
  GET_NEXT_PATIENT_FAIL,
  GET_NEXT_PATIENT_REQUEST,
  GET_NEXT_PATIENT_SUCCESS,
  GET_PAIN_STATS_FAIL,
  GET_PAIN_STATS_REQUEST,
  GET_PAIN_STATS_SUCCESS,
  GET_PATIENT_OVERVIEW_SUMMARY_FAIL,
  GET_PATIENT_OVERVIEW_SUMMARY_REQUEST,
  GET_PATIENT_OVERVIEW_SUMMARY_SUCCESS,
  GET_PATIENT_REPORTS_FAIL,
  GET_PATIENT_REPORTS_REQUEST,
  GET_PATIENT_REPORTS_SUCCESS,
  GET_PIE_CHART_STATS_FAIL,
  GET_PIE_CHART_STATS_REQUEST,
  GET_PIE_CHART_STATS_SUCCESS,
  GET_PINNED_NOTES_FAIL,
  GET_PINNED_NOTES_REQUEST,
  GET_PINNED_NOTES_SUCCESS,
  GET_TABS_COUNT_FAIL,
  GET_TABS_COUNT_REQUEST,
  GET_TABS_COUNT_SUCCESS,
  GET_UNPAGINATED_PATIENTS_FAIL,
  GET_UNPAGINATED_PATIENTS_REQUEST,
  GET_UNPAGINATED_PATIENTS_SUCCESS,
  GET_UNREAD_CHAT_MESSAGES_FAIL,
  GET_UNREAD_CHAT_MESSAGES_REQUEST,
  GET_UNREAD_CHAT_MESSAGES_SUCCESS,
  LOG_ENROLMENT_VISIT_FAIL,
  LOG_ENROLMENT_VISIT_REQUEST,
  LOG_ENROLMENT_VISIT_SUCCESS,
  PCM_ENROLMENT_CONSENT_FAIL,
  PCM_ENROLMENT_CONSENT_REQUEST,
  PCM_ENROLMENT_CONSENT_SUCCESS,
  REENROLL_PATIENT_FAIL,
  REENROLL_PATIENT_REQUEST,
  REENROLL_PATIENT_SUCCESS,
  RESET_ADD_PATIENT_DETAILS,
  RESET_ALL_PATIENTS,
  RESET_A_PATIENT_BY_PID,
  RESET_CREATE_ENROLMENT,
  RESET_DELETE_PATIENT,
  RESET_GENERATE_EVIDENCE,
  RESET_GET_TABS_COUNT,
  RESET_LISTING_STATES,
  RESET_LOG_ENROLMENT_VISIT,
  RESET_MINIMISED_NOTE,
  RESET_NEXT_PATIENT,
  RESET_PCM_ENROLMENT_CONSENT,
  RESET_PIE_CHART_STATS,
  RESET_RECORD_CONSENT,
  RESET_REENROLL_PATIENT,
  RESET_UNENROLL_PATIENT,
  RESET_UNPAGINATED_PATIENTS,
  RESET_UN_ENROLMENT_PROGRAM,
  RESET_UPDATE_CONTACT_NUMBER,
  RESET_UPDATE_MOBILE_PASSWORD,
  SET_ADDED_ON_VALUE,
  SET_ADDED_VIA,
  SET_ASSIGNED_TO,
  SET_CARE_PLAN,
  SET_CONSENT_STATUS,
  SET_CPT_CODES_ITEMS,
  SET_EDUCATION_GIVEN,
  SET_ENROLLMENT_STATUS,
  SET_FROM_CUSTOM_DATE_VALUE,
  SET_INITIATING_VISIT,
  SET_LISTING_TAB,
  SET_MOBILE_APP_ACTIVITY_VALUE,
  SET_NEXT_PATIENT_OBJECT,
  SET_PAGE_NUMBER,
  SET_PAGE_SIZE,
  SET_PROGRAM_VALUE,
  SET_QUERY,
  SET_SENT_CREDENTIALS,
  SET_SORTED_ITEMS,
  SET_TO_CUSTOM_DATE_VALUE,
  SET_UNENROLLED_BY_VALUE,
  SET_UNENROLLMENT_REASON_VALUE,
  UNENROLL_PATIENT_FAIL,
  UNENROLL_PATIENT_REQUEST,
  UNENROLL_PATIENT_SUCCESS,
  UN_ENROLMENT_PROGRAM_FAIL,
  UN_ENROLMENT_PROGRAM_REQUEST,
  UN_ENROLMENT_PROGRAM_SUCCESS,
  UPDATE_CONTACT_NUMBER_FAIL,
  UPDATE_CONTACT_NUMBER_REQUEST,
  UPDATE_CONTACT_NUMBER_SUCCESS,
  UPDATE_MOBILE_PASSWORD_FAIL,
  UPDATE_MOBILE_PASSWORD_REQUEST,
  UPDATE_MOBILE_PASSWORD_SUCCESS,
  UPDATE_PATIENT_FAIL,
  UPDATE_PATIENT_REQUEST,
  UPDATE_PATIENT_RESET,
  UPDATE_PATIENT_SUCCESS,
} from "../../assets/constants/patientConstants";
import axios from "axios";
import { BASE_URL } from "..";
import { apiRequest } from "../../utils/helpers/api";

// ================== PATIENT LISTINGS STATE =================
export const setPageNumber = (pageNumber) => ({
  type: SET_PAGE_NUMBER,
  payload: pageNumber,
});

export const setPageSize = (pageSize) => ({
  type: SET_PAGE_SIZE,
  payload: pageSize,
});
export const setListingTab = (tab) => ({
  type: SET_LISTING_TAB,
  payload: tab,
});
export const setAssignedTo = (assignedTo) => ({
  type: SET_ASSIGNED_TO,
  payload: assignedTo,
});

export const setEnrollmentStatus = (status) => ({
  type: SET_ENROLLMENT_STATUS,
  payload: status,
});

export const setProgramValue = (programValue) => ({
  type: SET_PROGRAM_VALUE,
  payload: programValue,
});

export const setMobileAppActivityValue = (mobileAppActivityValue) => ({
  type: SET_MOBILE_APP_ACTIVITY_VALUE,
  payload: mobileAppActivityValue,
});

export const setAddedOnValue = (addedOnValue) => ({
  type: SET_ADDED_ON_VALUE,
  payload: addedOnValue,
});

export const setUnenrollmentReasonValue = (unenrollmentReasonValue) => ({
  type: SET_UNENROLLMENT_REASON_VALUE,
  payload: unenrollmentReasonValue,
});

export const setUnenrolledByValue = (unenrolledByValue) => ({
  type: SET_UNENROLLED_BY_VALUE,
  payload: unenrolledByValue,
});

export const setSentCredentials = (status) => ({
  type: SET_SENT_CREDENTIALS,
  payload: status,
});

export const setEducationGiven = (educationGiven) => ({
  type: SET_EDUCATION_GIVEN,
  payload: educationGiven,
});

export const setAddedViaValue = (addedViaValue) => ({
  type: SET_ADDED_VIA,
  payload: addedViaValue,
});

export const setInitiatingVisitValue = (initiatingVisitValue) => ({
  type: SET_INITIATING_VISIT,
  payload: initiatingVisitValue,
});

export const setCarePlanValue = (carePlanValue) => ({
  type: SET_CARE_PLAN,
  payload: carePlanValue,
});

export const setConsentStatus = (consentStatus) => ({
  type: SET_CONSENT_STATUS,
  payload: consentStatus,
});

export const setQuery = (query) => ({
  type: SET_QUERY,
  payload: query,
});

export const setCptCodeItems = (cptItems) => ({
  type: SET_CPT_CODES_ITEMS,
  payload: cptItems,
});

export const setSortedItems = (sortedItems) => ({
  type: SET_SORTED_ITEMS,
  payload: sortedItems,
});

export const setFromCustomDateValue = (fromCustomDateValue) => ({
  type: SET_FROM_CUSTOM_DATE_VALUE,
  payload: fromCustomDateValue,
});

export const setToCustomDateValue = (toCustomDateValue) => ({
  type: SET_TO_CUSTOM_DATE_VALUE,
  payload: toCustomDateValue,
});

export const setNextPatientObjData = (nextPatientObj) => ({
  type: SET_NEXT_PATIENT_OBJECT,
  payload: nextPatientObj,
});

export const resetPatientListingStates = () => (dispatch) =>
  dispatch({
    type: RESET_LISTING_STATES,
  });

// ================== GET ALL PATIENTS  =========================
// page, pageSize, search, agentIds = [], enrollmentStatus = ""
export const getAllPatientsFunc = (listData) => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_PATIENTS_REQUEST });

    const token = Cookies.get("token");
    if (token) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${BASE_URL}/patient/get-list`,
        listData,
        config
      );

      dispatch({ type: GET_ALL_PATIENTS_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: GET_ALL_PATIENTS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================= GET  PATIENT OVERVIEW SUMMARY FUNC ==================
export const getPatientOverviewSummaryFunc =
  (patientId) => async (dispatch) => {
    dispatch({ type: GET_PATIENT_OVERVIEW_SUMMARY_REQUEST });

    const { data, error } = await apiRequest({
      method: "get",
      url: `/patient/overview-summary`,
      params: { patient_id: patientId },
    });

    if (data) {
      dispatch({ type: GET_PATIENT_OVERVIEW_SUMMARY_SUCCESS, payload: data });
    } else {
      dispatch({ type: GET_PATIENT_OVERVIEW_SUMMARY_FAIL, payload: error });
    }
  };

// ================= UPDATE CONTACT NUMBER FUNC ==================
export const updateContactNumberFunc = (contactObj) => async (dispatch) => {
  dispatch({ type: UPDATE_CONTACT_NUMBER_REQUEST });

  const { data, error } = await apiRequest({
    method: "post",
    url: `/patient/update-contact-number`,
    data: contactObj,
  });

  if (data) {
    dispatch({ type: UPDATE_CONTACT_NUMBER_SUCCESS, payload: data });
  } else {
    dispatch({ type: UPDATE_CONTACT_NUMBER_FAIL, payload: error });
  }
};

export const resetUpdateContactNumber = () => (dispatch) =>
  dispatch({
    type: RESET_UPDATE_CONTACT_NUMBER,
  });

// ================== GET ALL UNPAGINATED PATIENTS BY AGENCY  =========================
export const getAllAgencyPatientsFunc = (agencyIds) => async (dispatch) => {
  try {
    dispatch({ type: GET_AGENCY_PATIENTS_REQUEST });

    const token = Cookies.get("token");
    if (token) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.get(
        `${BASE_URL}/patient/get-count?${agencyIds}`,
        config
      );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({
        type: GET_AGENCY_PATIENTS_SUCCESS,
        payload: response?.data,
      });
    }
  } catch (error) {
    dispatch({
      type: GET_AGENCY_PATIENTS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================== GET ALL UNPAGINATED CASES  =========================
export const getUnpaginatedPatientsFunc = () => async (dispatch) => {
  try {
    dispatch({ type: GET_UNPAGINATED_PATIENTS_REQUEST });

    const token = Cookies.get("token");
    const agencyId = Cookies.get("agency_id_vita");
    if (token) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.get(
        `${BASE_URL}/patient/get-list-unpaginated?agency_id=${agencyId} `,
        config
      );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({
        type: GET_UNPAGINATED_PATIENTS_SUCCESS,
        payload: response?.data,
      });
    }
  } catch (error) {
    dispatch({
      type: GET_UNPAGINATED_PATIENTS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================== GET A CASE BY CASE ID  =========================
export const getPatientDetailByPatientId = (patientId) => async (dispatch) => {
  if (!Number(patientId)) return;

  try {
    dispatch({ type: GET_A_PATIENT_BY_PID_REQUEST });

    const token = Cookies.get("token");
    // const agencyId = Cookies.get("agency_id_vita");
    if (token) {
      // userInfo = JSON.parse(userInfo);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.get(
        `${BASE_URL}/patient/get?patient_id=${patientId}`,
        config
      );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({ type: GET_A_PATIENT_BY_PID_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: GET_A_PATIENT_BY_PID_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const resetPatientDetailByPatientId = () => (dispatch) =>
  dispatch({
    type: RESET_A_PATIENT_BY_PID,
  });

// ================== CREATE ENROLMENT FUNC  =========================
export const createEnrolmentFunc = (enrolmentObj) => async (dispatch) => {
  dispatch({ type: CREATE_ENROLMENT_REQUEST });

  const { data, error } = await apiRequest({
    method: "post",
    url: `/enrolment/create`,
    data: enrolmentObj,
  });

  if (data) {
    dispatch({ type: CREATE_ENROLMENT_SUCCESS, payload: data });
  } else {
    dispatch({ type: CREATE_ENROLMENT_FAIL, payload: error });
  }
};

// ================== UN ENROLMENT PROGRAM FUNC  =========================
export const unEnrolmentProgramFunc = (unenrolmentObj) => async (dispatch) => {
  dispatch({ type: UN_ENROLMENT_PROGRAM_REQUEST });

  const { data, error } = await apiRequest({
    method: "post",
    url: `/enrolment/unenroll`,
    data: unenrolmentObj,
  });

  if (data) {
    dispatch({ type: UN_ENROLMENT_PROGRAM_SUCCESS, payload: data });
  } else {
    dispatch({ type: UN_ENROLMENT_PROGRAM_FAIL, payload: error });
  }
};

export const resetUnEnrolmentProgram = () => (dispatch) =>
  dispatch({
    type: RESET_UN_ENROLMENT_PROGRAM,
  });

// ================== GET ENROLMENTS LIST FUNC  =========================
export const getEnrolmentsListFunc = (enrolmentObj) => async (dispatch) => {
  if (!Number(enrolmentObj?.patient_id)) return;

  dispatch({ type: GET_ENROLMENTS_LIST_REQUEST });

  const { data, error } = await apiRequest({
    method: "get",
    url: `/enrolment/list`,
    params: enrolmentObj,
  });

  if (data) {
    dispatch({ type: GET_ENROLMENTS_LIST_SUCCESS, payload: data });
  } else {
    dispatch({ type: GET_ENROLMENTS_LIST_FAIL, payload: error });
  }
};

export const resetCreateEnrolment = () => (dispatch) =>
  dispatch({
    type: RESET_CREATE_ENROLMENT,
  });

// ================== LOG ENROLMENT VISIT FUNC  =========================
export const logEnrolmentVisitFunc = (enrolmentObj) => async (dispatch) => {
  dispatch({ type: LOG_ENROLMENT_VISIT_REQUEST });

  const { data, error } = await apiRequest({
    method: "post",
    url: `/enrolment/record-visit`,
    data: enrolmentObj,
  });

  if (data) {
    dispatch({ type: LOG_ENROLMENT_VISIT_SUCCESS, payload: data });
  } else {
    dispatch({ type: LOG_ENROLMENT_VISIT_FAIL, payload: error });
  }
};

export const resetLogEnrolmentVisit = () => (dispatch) =>
  dispatch({
    type: RESET_LOG_ENROLMENT_VISIT,
  });

// ================== PCM ENROLMENT CONSENT FUNC  =========================
export const addPcmEnrolmentConsentFunc =
  (enrolmentObj) => async (dispatch) => {
    dispatch({ type: PCM_ENROLMENT_CONSENT_REQUEST });

    const { data, error } = await apiRequest({
      method: "post",
      url: `/enrolment/record-consent`,
      data: enrolmentObj,
    });

    if (data) {
      dispatch({ type: PCM_ENROLMENT_CONSENT_SUCCESS, payload: data });
    } else {
      dispatch({ type: PCM_ENROLMENT_CONSENT_FAIL, payload: error });
    }
  };

export const resetPcmEnrolmentConsent = () => (dispatch) =>
  dispatch({
    type: RESET_PCM_ENROLMENT_CONSENT,
  });

// ================== REENROLL PATIENT FUNC  =========================
export const reEnrollPatientFunc = (patientObj) => async (dispatch) => {
  try {
    dispatch({ type: REENROLL_PATIENT_REQUEST });

    const token = Cookies.get("token");
    // const agencyId = Cookies.get("agency_id_vita");
    if (token) {
      // userInfo = JSON.parse(userInfo);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${BASE_URL}/patient/reenroll`,
        patientObj,
        config
      );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({ type: REENROLL_PATIENT_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: REENROLL_PATIENT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const resetReEnrollPatient = () => (dispatch) =>
  dispatch({
    type: RESET_REENROLL_PATIENT,
  });

// ================== GET TABS COUNT ACTIONS  =========================
export const getTabsCountFunc = () => async (dispatch) => {
  try {
    dispatch({ type: GET_TABS_COUNT_REQUEST });

    const token = Cookies.get("token");
    const agencyId = Cookies.get("agency_id_vita");
    if (token) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.get(
        `${BASE_URL}/patient/get-tabs-count?agency_id=${agencyId}`,
        config
      );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({ type: GET_TABS_COUNT_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: GET_TABS_COUNT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const resetTabsCount = () => (dispatch) =>
  dispatch({
    type: RESET_GET_TABS_COUNT,
  });

// ================== GET NEXT PATIENT ACTIONS  =========================
export const getNextPatientFunc = (patientData) => async (dispatch) => {
  try {
    dispatch({ type: GET_NEXT_PATIENT_REQUEST });

    const token = Cookies.get("token");
    if (token) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${BASE_URL}/patient/get-next`,
        patientData,
        config
      );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({ type: GET_NEXT_PATIENT_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: GET_NEXT_PATIENT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const resetNextPatient = () => (dispatch) =>
  dispatch({
    type: RESET_NEXT_PATIENT,
  });

// ================== ADD RECORD CONSENT  =========================
export const addRecordConsentFunc = (recordObj) => async (dispatch) => {
  try {
    dispatch({ type: ADD_RECORD_CONSENT_REQUEST });

    const token = Cookies.get("token");
    if (token) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${BASE_URL}/patient/record-consent`,
        recordObj,
        config
      );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({ type: ADD_RECORD_CONSENT_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: ADD_RECORD_CONSENT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const resetRecordConsent = () => (dispatch) =>
  dispatch({
    type: RESET_RECORD_CONSENT,
  });

// =================GET ENROLMENT TIMELINE FUNC ==================
export const getEnrolmentTimelineFunc = (patientId) => async (dispatch) => {
  if (!Number(patientId)) return;

  dispatch({ type: GET_ENROLMENT_TIMELINE_REQUEST });

  const { data, error } = await apiRequest({
    method: "get",
    url: `/enrolment/journey`,
    params: { patient_id: patientId },
  });

  if (data) {
    dispatch({ type: GET_ENROLMENT_TIMELINE_SUCCESS, payload: data });
  } else {
    dispatch({ type: GET_ENROLMENT_TIMELINE_FAIL, payload: error });
  }
};

// ================== ADD EQUIP SETUPD FUNC   =========================
export const addEquipSetupFunc = (recordObj) => async (dispatch) => {
  try {
    dispatch({ type: EQUIP_SETUP_REQUEST });

    const token = Cookies.get("token");
    if (token) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${BASE_URL}/patient/record-equipment-setup`,
        recordObj,
        config
      );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({ type: EQUIP_SETUP_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: EQUIP_SETUP_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================== ADD EDUCATION SETUPD FUNC   =========================
export const addEducationSetupFunc = (recordObj) => async (dispatch) => {
  try {
    dispatch({ type: EDUCATION_SETUP_REQUEST });

    const token = Cookies.get("token");
    if (token) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${BASE_URL}/patient/record-patient-education`,
        recordObj,
        config
      );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({ type: EDUCATION_SETUP_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: EDUCATION_SETUP_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================== UNENROLL PATIENT ACTION  =========================
export const unEnrollPatientFunc = (unEnrollObj) => async (dispatch) => {
  try {
    dispatch({ type: UNENROLL_PATIENT_REQUEST });

    const token = Cookies.get("token");
    if (token) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${BASE_URL}/patient/unenroll`,
        unEnrollObj,
        config
      );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({ type: UNENROLL_PATIENT_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: UNENROLL_PATIENT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const resetUnEnrollPatient = () => (dispatch) =>
  dispatch({
    type: RESET_UNENROLL_PATIENT,
  });

// ================== GENERATE EVIDENCE REPORT  ACTIONS  =========================
export const generateEvidenceReportFunc = (reportObj) => async (dispatch) => {
  try {
    dispatch({ type: GENERATE_EVIDENCE_REQUEST });

    const token = Cookies.get("token");
    if (token) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${BASE_URL}/patient/generate-eoc`,
        reportObj,
        config
      );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({
        type: GENERATE_EVIDENCE_SUCCESS,
        payload: response?.data,
      });
    }
  } catch (error) {
    dispatch({
      type: GENERATE_EVIDENCE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const resetEvidenceReport = () => (dispatch) => {
  dispatch({ type: RESET_GENERATE_EVIDENCE });
};

// ================== GET PATIENT REPORTS  ACTIONS  =========================
export const getPatientReportsFunc = (patientId) => async (dispatch) => {
  try {
    dispatch({ type: GET_PATIENT_REPORTS_REQUEST });

    const token = Cookies.get("token");
    if (token) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.get(
        `${BASE_URL}/report/get-by-patient?patient_id=${patientId}&report_generation_type=scheduled`,
        config
      );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({
        type: GET_PATIENT_REPORTS_SUCCESS,
        payload: response?.data,
      });
    }
  } catch (error) {
    dispatch({
      type: GET_PATIENT_REPORTS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================== GET CLIENT PAIN LOGS ACTIONS  =========================
export const getClientPainlogsFunc =
  (
    patientId,
    startDate,
    endDate,
    selectedPain,
    last24Hours = false,
    sinceTime
  ) =>
  async (dispatch) => {
    try {
      dispatch({ type: GET_CLIENT_PAINLOGS_REQUEST });

      const token = Cookies.get("token");
      // const agencyId = Cookies.get("agency_id_vita");
      if (token) {
        // userInfo = JSON.parse(userInfo);
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };

        let response;

        if (last24Hours) {
          response = await axios.get(
            `${BASE_URL}/pain-entry/get?patient_id=${patientId}&since=${encodeURIComponent(sinceTime)}&filter=${selectedPain}`,
            config
          );
        } else {
          response = await axios.get(
            `${BASE_URL}/pain-entry/get?patient_id=${patientId}&start_date=${startDate}&end_date=${endDate}&filter=${selectedPain}`,
            config
          );
        }

        if (!response?.data?.ok) {
          throw new Error(response?.data?.message);
        }

        dispatch({
          type: GET_CLIENT_PAINLOGS_SUCCESS,
          payload: response?.data,
        });
      }
    } catch (error) {
      dispatch({
        type: GET_CLIENT_PAINLOGS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// ================== GET LAST LAB DATE ACTION  =========================
export const getLastLabDateFunc = (patientObj) => async (dispatch) => {
  dispatch({ type: GET_LAST_LAB_DATE_REQUEST });

  const { data, error } = await apiRequest({
    method: "get",
    url: `/lab-report/get-last-report-date`,
    params: patientObj,
  });

  if (data) {
    dispatch({ type: GET_LAST_LAB_DATE_SUCCESS, payload: data });
  } else {
    dispatch({ type: GET_LAST_LAB_DATE_FAIL, payload: error });
  }
};

// ================== GET PAIN STATS ACTIONS  =========================
export const getPainStatsFunc =
  (patientId, startDate, endDate, last24Hours = false, sinceTime) =>
  async (dispatch) => {
    try {
      dispatch({ type: GET_PAIN_STATS_REQUEST });

      const token = Cookies.get("token");
      // const agencyId = Cookies.get("agency_id_vita");
      if (token) {
        // userInfo = JSON.parse(userInfo);
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };

        let response;

        if (last24Hours) {
          response = await axios.get(
            `${BASE_URL}/pain-entry/get-pain-chart-stats?patient_id=${patientId}&since=${encodeURIComponent(sinceTime)}`,
            config
          );
        } else {
          response = await axios.get(
            `${BASE_URL}/pain-entry/get-pain-chart-stats?patient_id=${patientId}&start_date=${startDate}&end_date=${endDate}`,
            config
          );
        }

        if (!response?.data?.ok) {
          throw new Error(response?.data?.message);
        }

        dispatch({
          type: GET_PAIN_STATS_SUCCESS,
          payload: response?.data,
        });
      }
    } catch (error) {
      dispatch({
        type: GET_PAIN_STATS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// ================== GET MEDICINE DATA ACTIONS  =========================
export const getMedicineDataFunc =
  (patientId, startDate, endDate) => async (dispatch) => {
    try {
      dispatch({ type: GET_MEDICINE_DATA_REQUEST });

      const token = Cookies.get("token");
      if (token) {
        // userInfo = JSON.parse(userInfo);
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };

        const response = await axios.get(
          `${BASE_URL}/medicine-entry/get?patient_id=${patientId}&start_date=${startDate}&end_date=${endDate}`,
          config
        );

        if (!response?.data?.ok) {
          throw new Error(response?.data?.message);
        }

        dispatch({
          type: GET_MEDICINE_DATA_SUCCESS,
          payload: response?.data,
        });
      }
    } catch (error) {
      dispatch({
        type: GET_MEDICINE_DATA_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// ================== GET CHART PAIN LOGS ACTIONS  =========================
export const getChartPainlogsFunc =
  (
    patientId,
    startDate,
    endDate,
    selectedPain,
    last24Hours = false,
    sinceTime
  ) =>
  async (dispatch) => {
    try {
      dispatch({ type: GET_CHART_PAINLOGS_REQUEST });

      const token = Cookies.get("token");
      // const agencyId = Cookies.get("agency_id_vita");
      if (token) {
        // userInfo = JSON.parse(userInfo);
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };

        let response;

        if (last24Hours) {
          response = await axios.get(
            `${BASE_URL}/pain-entry/get?patient_id=${patientId}&since=${encodeURIComponent(sinceTime)}&filter=${selectedPain}`,
            config
          );
        } else {
          response = await axios.get(
            `${BASE_URL}/pain-entry/get?patient_id=${patientId}&start_date=${startDate}&end_date=${endDate}&filter=${selectedPain}`,
            config
          );
        }

        if (!response?.data?.ok) {
          throw new Error(response?.data?.message);
        }

        dispatch({
          type: GET_CHART_PAINLOGS_SUCCESS,
          payload: response?.data,
        });
      }
    } catch (error) {
      dispatch({
        type: GET_CHART_PAINLOGS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// ================== ADD NEW CASE ACTIONS  =========================
export const addNewPatientFunc = (newCaseData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_NEW_PATIENT_REQUEST });

    const token = Cookies.get("token");
    // const agencyId = Cookies.get("agency_id_vita");
    if (token) {
      // userInfo = JSON.parse(userInfo);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${BASE_URL}/case/create`,
        newCaseData,
        config
      );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({
        type: ADD_NEW_PATIENT_SUCCESS,
        payload: response?.data,
      });

      // dispatch({ type: GET_ALL_PATIENTS_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: ADD_NEW_PATIENT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================== UPDATE CASE ACTIONS  =========================
export const updateCaseFunc = (patientData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_PATIENT_REQUEST });

    const token = Cookies.get("token");
    // const agencyId = Cookies.get("agency_id_vita");
    if (token) {
      // userInfo = JSON.parse(userInfo);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${BASE_URL}/patient/update`,
        patientData,
        config
      );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({
        type: UPDATE_PATIENT_SUCCESS,
        payload: response?.data,
      });

      // dispatch({ type: GET_ALL_PATIENTS_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: UPDATE_PATIENT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================== DELETE CASE ACTIONS  =========================
export const deletePatientFunc = (patientId) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_PATIENT_REQUEST });

    const token = Cookies.get("token");
    if (token) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${BASE_URL}/patient/delete`,
        {
          patient_id: patientId,
        },
        config
      );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({
        type: DELETE_PATIENT_SUCCESS,
      });

      // dispatch({ type: GET_ALL_PATIENTS_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: DELETE_PATIENT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================== GET DASHBOARD ANALYTICS ACTIONS  =========================
export const getDashboardAnalyticsFunc = (agentId) => async (dispatch) => {
  try {
    dispatch({ type: GET_DASHBOARD_ANALYTICS_REQUEST });

    const token = Cookies.get("token");
    const agency_id = Cookies.get("agency_id_vita");
    if (token) {
      // userInfo = JSON.parse(userInfo);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      let response;
      if (agentId === "all") {
        response = await axios.get(
          `${BASE_URL}/dashboard/get-metrics?agency_id=${agency_id}`,
          config
        );
      } else {
        response = await axios.get(
          `${BASE_URL}/dashboard/get-metrics?agency_id=${agency_id}&assigned_to=${agentId}`,
          config
        );
      }

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({
        type: GET_DASHBOARD_ANALYTICS_SUCCESS,
        payload: response?.data,
      });
    }
  } catch (error) {
    dispatch({
      type: GET_DASHBOARD_ANALYTICS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================== GET DASHBOARD ALERTS ACTIONS  =========================
export const getDashboardAlertsFunc = (agentId) => async (dispatch) => {
  try {
    dispatch({ type: GET_DASHBOARD_ALERTS_REQUEST });

    const token = Cookies.get("token");
    const agency_id = Cookies.get("agency_id_vita");
    if (token) {
      // userInfo = JSON.parse(userInfo);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      let response;
      if (agentId === "all") {
        response = await axios.get(
          `${BASE_URL}/dashboard/get-alerts?agency_id=${agency_id}`,
          config
        );
      } else {
        response = await axios.get(
          `${BASE_URL}/dashboard/get-alerts?agency_id=${agency_id}&assigned_to=${agentId}`,
          config
        );
      }

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({
        type: GET_DASHBOARD_ALERTS_SUCCESS,
        payload: response?.data,
      });
    }
  } catch (error) {
    dispatch({
      type: GET_DASHBOARD_ALERTS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================== GET DASHBOARD UNREAD CHAT MESSAGES ACTIONS  =========================
export const getUnreadChatMessagesFunc = (agentId) => async (dispatch) => {
  try {
    dispatch({ type: GET_UNREAD_CHAT_MESSAGES_REQUEST });

    const token = Cookies.get("token");
    const agency_id = Cookies.get("agency_id_vita");
    if (token) {
      // userInfo = JSON.parse(userInfo);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      let response;
      if (agentId === "all") {
        response = await axios.get(
          `${BASE_URL}/dashboard/get-unread-chats?agency_id=${agency_id}`,
          config
        );
      } else {
        response = await axios.get(
          `${BASE_URL}/dashboard/get-unread-chats?agency_id=${agency_id}&assigned_to=${agentId}`,
          config
        );
      }

      // const response = await axios.get(
      //   `${BASE_URL}/dashboard/get-unread-chats`,
      //   config
      // );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({
        type: GET_UNREAD_CHAT_MESSAGES_SUCCESS,
        payload: response?.data,
      });
    }
  } catch (error) {
    dispatch({
      type: GET_UNREAD_CHAT_MESSAGES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================== GET PIE CHART STATS ACTIONS  =========================
export const getPieChartStatsFunc =
  (clientId, caseId, startDate, endDate) => async (dispatch) => {
    try {
      dispatch({ type: GET_PIE_CHART_STATS_REQUEST });

      const token = Cookies.get("token");
      if (token) {
        // userInfo = JSON.parse(userInfo);
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };

        const response = await axios.get(
          `${BASE_URL}/pain-entry/get-stats?start_date=${startDate}
          &end_date=${endDate}&client_id=${clientId}&case_id=${caseId}`,
          config
        );

        if (!response?.data?.ok) {
          throw new Error(response?.data?.message);
        }

        dispatch({
          type: GET_PIE_CHART_STATS_SUCCESS,
          payload: response?.data,
        });
      }
    } catch (error) {
      dispatch({
        type: GET_PIE_CHART_STATS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// ================== GET PINNED NOTES ACTIONS  =========================
export const getPinnedNotesFunc = (patientId) => async (dispatch) => {
  try {
    dispatch({ type: GET_PINNED_NOTES_REQUEST });

    const token = Cookies.get("token");
    const agencyId = Cookies.get("agency_id_vita");

    if (token) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.get(
        `${BASE_URL}/patient-note/get-pinned-notes?patient_id=${patientId}&agency_id=${agencyId}`,
        config
      );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({
        type: GET_PINNED_NOTES_SUCCESS,
        payload: response?.data,
      });
    }
  } catch (error) {
    dispatch({
      type: GET_PINNED_NOTES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================== GET PINNED NOTES ACTIONS  =========================
export const deletePatientNoteFunc = (noteObj) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_PATIENT_NOTE_REQUEST });

    const token = Cookies.get("token");

    if (token) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${BASE_URL}/patient-note/delete`,
        noteObj,
        config
      );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({
        type: DELETE_PATIENT_NOTE_SUCCESS,
        payload: response?.data,
      });
    }
  } catch (error) {
    dispatch({
      type: DELETE_PATIENT_NOTE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================== GET MINIMISED NOTE ACTIONS  =========================
export const getMinimisedNoteFunc = (patientId) => async (dispatch) => {
  try {
    dispatch({ type: GET_MINIMISED_NOTE_REQUEST });

    const token = Cookies.get("token");
    const agencyId = Cookies.get("agency_id_vita");

    if (token) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.get(
        `${BASE_URL}/patient-note/get-minimized-notes?patient_id=${patientId}&agency_id=${agencyId}`,
        config
      );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({
        type: GET_MINIMISED_NOTE_SUCCESS,
        payload: response?.data,
      });
    }
  } catch (error) {
    dispatch({
      type: GET_MINIMISED_NOTE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const resetMinimisedNote = () => async (dispatch) => {
  dispatch({ type: RESET_MINIMISED_NOTE });
};

// ================== ADD PATIENT DETAILS ACTIONS  =========================
export const addPatientDetailsFunc = (patientsData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_PATIENT_DETAILS_REQUEST });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/patient/register-qr-scanned`,
      patientsData,
      config
    );

    if (!response?.data?.ok) {
      throw new Error(response?.data?.message);
    }

    dispatch({
      type: ADD_PATIENT_DETAILS_SUCCESS,
      payload: response?.data,
    });
  } catch (error) {
    dispatch({
      type: ADD_PATIENT_DETAILS_FAIL,
      payload:
        error.response && error.response.data.msg
          ? error.response.data.msg
          : error.message,
    });
  }
};

export const resetPatientDetails = () => async (dispatch) => {
  dispatch({ type: RESET_ADD_PATIENT_DETAILS });
};

// ================== ADD PATIENT DETAILS ACTIONS  =========================
export const addPatientPasswordFunc =
  (passwordData, patientToken) => async (dispatch) => {
    try {
      dispatch({ type: ADD_PATIENT_PASSWORD_REQUEST });

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${patientToken}`,
        },
      };

      const response = await axios.post(
        `${BASE_URL}/patient/add-password`,
        passwordData,
        config
      );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.msg);
      }

      dispatch({
        type: ADD_PATIENT_PASSWORD_SUCCESS,
        payload: response?.data,
      });
    } catch (error) {
      dispatch({
        type: ADD_PATIENT_PASSWORD_FAIL,
        payload:
          error.response && error.response.data.msg
            ? error.response.data.msg
            : error.message,
      });
    }
  };

// ================= UPDATE MOBILE APP PASSWORD FUNC ==================
export const updateMobileAppPasswordFunc = (mobileObj) => async (dispatch) => {
  dispatch({ type: UPDATE_MOBILE_PASSWORD_REQUEST });

  const { data, error } = await apiRequest({
    method: "post",
    url: `/patient/update-password-from-web`,
    data: mobileObj,
  });

  if (data) {
    dispatch({ type: UPDATE_MOBILE_PASSWORD_SUCCESS, payload: data });
  } else {
    dispatch({ type: UPDATE_MOBILE_PASSWORD_FAIL, payload: error });
  }
};

export const resetUpdateMobilePassword = () => async (dispatch) => {
  dispatch({ type: RESET_UPDATE_MOBILE_PASSWORD });
};

// Fire-and-forget: notify patient that caregiver opened their logs for review
export const notifyPatientReviewStartedFunc = (patientId) => async () => {
  try {
    const token = Cookies.get("token");
    if (!token || !patientId) return;

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    await axios.post(
      `${BASE_URL}/notification/notify-review-started`,
      { patient_id: patientId },
      config
    );
  } catch (error) {
    console.log("Error notifying patient of review started", error);
  }
};

export const resetPatientPassword = () => async (dispatch) => {
  dispatch({ type: RESET_ADD_PATIENT_DETAILS });
};

export const resetNewPatient = () => async (dispatch) => {
  dispatch({ type: ADD_NEW_PATIENT_SUCCESS, payload: { ok: false } });
};

export const resetDeletePatient = () => async (dispatch) => {
  dispatch({
    type: RESET_DELETE_PATIENT,
  });
};

export const resetUpdatePatient = () => (dispatch) =>
  dispatch({
    type: UPDATE_PATIENT_RESET,
  });

export const resetAllPatients = () => async (dispatch) =>
  dispatch({
    type: RESET_ALL_PATIENTS,
  });

export const resetUnpaginatedPatients = () => async (dispatch) =>
  dispatch({
    type: RESET_UNPAGINATED_PATIENTS,
  });

export const resetPieChartStats = () => async (dispatch) => {
  dispatch({ type: RESET_PIE_CHART_STATS });
};

export const resetClientPainlogs = () => async (dispatch) => {
  dispatch({ type: GET_CLIENT_PAINLOGS_SUCCESS, payload: { ok: false } });
};

// ================== GET QOL ANSWERS BY DATE RANGE =========================
export const getQolAnswersFunc =
  (patientId, agencyId, startDate, endDate) => async (dispatch) => {
    try {
      dispatch({ type: GET_QOL_ANSWERS_REQUEST });

      const token = Cookies.get("token");
      if (token) {
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };

        const response = await axios.get(
          `${BASE_URL}/qol/get-by-date-range?patient_id=${patientId}&agency_id=${agencyId}&start_date=${startDate}&end_date=${endDate}`,
          config
        );

        if (!response?.data?.ok) {
          throw new Error(response?.data?.msg || response?.data?.message);
        }

        dispatch({
          type: GET_QOL_ANSWERS_SUCCESS,
          payload: response?.data,
        });
      }
    } catch (error) {
      dispatch({
        type: GET_QOL_ANSWERS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// ================== GET BMI RESPONSES =========================
export const getBmiResponsesFunc =
  (patientId, agencyId) => async (dispatch) => {
    try {
      dispatch({ type: GET_BMI_RESPONSES_REQUEST });

      const token = Cookies.get("token");
      if (token) {
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };

        const agencyQuery = agencyId ? `&agency_id=${agencyId}` : "";
        const response = await axios.get(
          `${BASE_URL}/bmi-response/get?patient_id=${patientId}${agencyQuery}`,
          config
        );

        if (!response?.data?.ok) {
          throw new Error(response?.data?.msg || response?.data?.message);
        }

        dispatch({
          type: GET_BMI_RESPONSES_SUCCESS,
          payload: response?.data,
        });
      }
    } catch (error) {
      dispatch({
        type: GET_BMI_RESPONSES_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// ================== GET PHQ-9 RESPONSES =========================
export const getPhqResponsesFunc =
  (patientId, agencyId) => async (dispatch) => {
    try {
      dispatch({ type: GET_PHQ_RESPONSES_REQUEST });

      const token = Cookies.get("token");
      if (token) {
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };

        const agencyQuery = agencyId ? `&agency_id=${agencyId}` : "";
        const response = await axios.get(
          `${BASE_URL}/phq-response/get?patient_id=${patientId}${agencyQuery}`,
          config
        );

        if (!response?.data?.ok) {
          throw new Error(response?.data?.msg || response?.data?.message);
        }

        dispatch({
          type: GET_PHQ_RESPONSES_SUCCESS,
          payload: response?.data,
        });
      }
    } catch (error) {
      dispatch({
        type: GET_PHQ_RESPONSES_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };
